import { FC, ReactNode } from 'react'
import { CouponAvatar, CouponAvatarType } from './Avatar'
import { CouponOption, CouponOptionType } from './Option'

const Coupon: FC & CouponAvatarType & CouponOptionType = (): ReactNode => <></>

Coupon.Avatar = CouponAvatar
Coupon.Option = CouponOption

export default Coupon
